
















































































// Vue
import Vue, { PropType } from "vue";
// Vuelidate
import { validationMixin } from "vuelidate";
// Models
import { JobSiteModel, LocationType } from "@/core/api/apiClient";
import ConfirmationDialog from "@/core/components/content/_dialogs/ConfirmationDialog.vue";

export default Vue.extend({
  name: "UpdateJobsiteDialog",
  mixins: [validationMixin],
  components: {
    ConfirmationDialog
  },
  props: {
    jobSite: {
      type: Object as PropType<JobSiteModel>,
      required: true
    }
  },

  data() {
    return {
      dialog: false,
      isValid: false,

      name: "",
      streetAddress: "",
      cityAddress: "",
      notes: ""
    };
  },

  methods: {
    initialize(): void {
      if (this.jobSite) {
        this.name = this.jobSite.name ?? "";
        this.streetAddress = this.jobSite.streetAddress ?? "";
        this.cityAddress = this.jobSite.cityAddress ?? "";
        this.notes = this.jobSite.notes ?? "";
      }
    },

    checkValid(): boolean {
      if (this.name || this.streetAddress) return true;
      return false;
    },

    submit(): void {
      if (!this.checkValid()) return;

      // Default the Jobsite Name to it's StreetAddress if no Name is provided
      if (!this.name) this.name = this.streetAddress;

      const updatedJobSite: JobSiteModel = new JobSiteModel({
        jobSiteId: this.jobSite.jobSiteId,
        name: this.name,
        streetAddress: this.streetAddress,
        locationType: LocationType.Address,
        cityAddress: this.cityAddress,
        notes: this.notes,
        lastUsedTimestamp: this.jobSite.lastUsedTimestamp
      });

      this.$emit("updated-jobsite", updatedJobSite);
      this.dialog = false;
    },

    deleteJobSite(): void {
      const deletedJobSite: JobSiteModel = new JobSiteModel({
        jobSiteId: this.jobSite.jobSiteId,
        name: this.name,
        streetAddress: this.streetAddress,
        locationType: LocationType.Address,
        cityAddress: this.cityAddress,
        notes: this.notes,
        lastUsedTimestamp: this.jobSite.lastUsedTimestamp
      });

      this.$emit("deleted-jobsite", deletedJobSite);
      this.close();
    },

    close() {
      this.name = "";
      this.streetAddress = "";
      this.cityAddress = "";
      this.notes = "";

      this.dialog = false;
    }
  },
  watch: {
    jobSite: {
      handler(newJobSite) {
        this.name = newJobSite.name ?? newJobSite.name ?? "";
        this.streetAddress = newJobSite.streetAddress ?? newJobSite.streetAddress ?? "";
        this.cityAddress = newJobSite.cityAddress ?? newJobSite.cityAddress ?? "";
        this.notes = newJobSite.notes ?? newJobSite.notes ?? "";
      },
      immediate: true
    }
  }
});
